export const SET_EDIT_SEASON_DATA = 'SET_EDIT_SEASON_DATA';

export function setEditSeasonData(seat) {
  return {
    type: SET_EDIT_SEASON_DATA,
    seat,
  };
}
